import React, { useState, useEffect, useContext, useRef } from "react";
import { useAuth } from "../auth/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import ForgotPasswordModal from "../components/ForgotPasswordModal";
import { MonoButton } from "../kits";
import PaperBG from "../kits/DesignKit/PaperBG";
import RoughBorder from "../kits/LayoutKit/RoughBorder";
import { NameContext } from "../context/NameContext";

export default function Login() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const { login, loginAsDemoUser } = useAuth();
  const navigate = useNavigate();
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [emailExists, setEmailExists] = useState(null);
  const [checkingEmail, setCheckingEmail] = useState(false);
  const { name } = useContext(NameContext);

  // Ref für RoughBorder
  const formRef = useRef();

  // Reset E-Mail Prüfung wenn E-Mail sich ändert
  useEffect(() => {
    setEmailExists(null);
  }, [formData.email]);

  // E-Mail existiert Prüfung
  const checkEmailExists = async () => {
    const email = formData.email.trim();
    if (email === "" || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setEmailExists(null);
      return;
    }
    setCheckingEmail(true);
    try {
      const res = await fetch(
        `https://www.denisbitter.de/stage01/api/check_email_api.php?email=${encodeURIComponent(email)}`
      );
      if (!res.ok) {
        setEmailExists(null);
      } else {
        const json = await res.json();
        setEmailExists(json.exists);
      }
    } catch (err) {
      console.error("Fehler beim Prüfen der E-Mail:", err);
      setEmailExists(null);
    }
    setCheckingEmail(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDemoLogin = () => {
    loginAsDemoUser();
    navigate("/dashboard");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await fetch(
        "https://www.denisbitter.de/stage01/api/login_api.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (jsonErr) {
        console.error("❌ JSON Fehler:", jsonErr, "Antwort war:", text);
        setError("Unerwartete Serverantwort.");
        return;
      }
      if (response.ok && data.success && data.token) {
        login(data.token, data.userId, data.mustChange === 1);
        if (data.mustChange === 1) {
          navigate("/reset-password");
        } else {
          navigate("/dashboard");
        }
      } else {
        setError(data.message || "Login fehlgeschlagen.");
      }
    } catch (err) {
      console.error("❌ Netzwerkfehler:", err);
      setError("Server nicht erreichbar.");
    }
  };

  return (
    <PaperBG>
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="relative">
          {/* Formular */}
          <form
            ref={formRef}
            onSubmit={handleSubmit}
            className="
            max-w-md 
            w-full 
            py-11 
            px-6 
            text-xs 
            text-center 
            text-black 
            bg-gradient-to-br from-gray-100 via-white to-gray-100/50  
            rounded-xl 
            shadow-md 
            border 
            border-gray-900"
          >
            <p className="text-xs text-gray-500 mt-6 mb-6 font-mono leading-relaxed">
              Moin, 
              {name ? `${name}, ` : ""} <br />wenn du einfach mal ausprobieren möchtest,  
              wie unser Kurs Cockpit funktioniert – klick auf <br />{" "}
              <span
                onClick={handleDemoLogin}
                className="
                underline 
                cursor-pointer 
                text-black 
                hover:bg-gray-950 hover:text-orange-300
                hover:pl-3
                hover:pr-3
                hover:mb-1
                hover:mt-1
                "
              >
                {name ? `${name} ` : ""}- Lern Einfach. Cockpit
              </span>
              <br />
              Ganz ohne Anmeldung, aber mit echtem Einblick.
            </p>
            <h3 className="text-sm font-mono mb-4">Dein Kurs Dashboard</h3>
            {/* E-Mail-Feld mit onBlur für E-Mail-Prüfung */}
            <input
              type="email"
              name="email"
              placeholder="E-Mail"
              value={formData.email}
              onChange={handleChange}
              onBlur={checkEmailExists}
              required
              className="font-mono text-xs w-full mb-3 px-4 py-2 border rounded-lg focus:outline-none focus:ring-1 text-black focus:ring-gray-900 text-center"
            />
            {checkingEmail && (
              <p className="text-black text-xs mb-2">Prüfe E-Mail …</p>
            )}
            {emailExists === false && (
              <p className="text-sm text-red-500 mb-2">
                Diese E-Mail ist noch nicht registriert.
                <Link to="/register" className="underline ml-1">
                  Benutzerkonto anlegen
                </Link>
              </p>
            )}
            {/* Passwort-Feld */}
            <input
              type="password"
              name="password"
              placeholder="Passwort"
              value={formData.password}
              onChange={handleChange}
              required
              className="font-mono text-xs w-full mb-3 px-4 py-2 border rounded-lg focus:outline-none focus:ring-1 text-black focus:ring-gray-900 text-center"
            />
            <MonoButton type="submit" className="w-full py-2 rounded mb-2 ">
              Einloggen
            </MonoButton>
            <Link to="/" className="block mt-4 w-full">
              <MonoButton className="w-full">Zurück zur Startseite</MonoButton>
            </Link>
  
            <p
              className="text-xs 
              text-gray-400 
              underline 
              cursor-pointer 
              mt-10 
              font-mono 
              hover:text-orange-300
               hover:bg-gray-900
           
             
              "
              onClick={() => setShowForgotModal(true)}
            >
              Passwort vergessen?
            </p>

            
            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
          </form>
          {/* RoughBorder um das Formular */}
          <RoughBorder
            parentRef={formRef}
            radius={13}
            padding={3}
       color="#AC8E66" 
            strokeWidth={0.3}
            roughness={1}
            bowing={1.2}
          />
        </div>
        {showForgotModal && (
          <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />
        )}
      </div>
    </PaperBG>
  );
}
